import { EMPTY_WAGON_QUANTITY } from '../constant';

export function filterByEmptyWagon(data) {
  return data.filter(({ quantity }) => +quantity !== EMPTY_WAGON_QUANTITY);
}
